// Ids match sales.payment_terms_group, seeded by pricing_engine_v2. COD is deliberately not a
// member -- it is a single payment term (net_days = 0), not a group of terms, so it is addressed
// by its own paymentTermsId like any other term. NET keeps its original id (2, not renumbered to
// 1) because the gap costs nothing and renumbering would churn every paymentTermsGroupId: 2
// fixture for no functional gain. See payment-terms-group-for.ts for how COD is identified.
export var PaymentTermsGroup;
(function (PaymentTermsGroup) {
    PaymentTermsGroup[PaymentTermsGroup["NET"] = 2] = "NET";
})(PaymentTermsGroup || (PaymentTermsGroup = {}));
//# sourceMappingURL=payment-terms-group.js.map